import {Directive, Input, OnDestroy, TemplateRef, ViewContainerRef} from '@angular/core';
import {PackageService} from '../api/services/package.service';
import {Subject, takeUntil} from 'rxjs';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[appHasPackage]',
  standalone: true
})
export class HasPackageDirective implements OnDestroy {
  private destroy$ = new Subject<void>();
  private packageNames: string[] = [];
  private hasView = false;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private packageService: PackageService
  ) {
    // Subscribe to package changes to handle delayed initialization
    this.packageService.userPackageStream()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.updateView();
      });
  }

  @Input() set appHasPackage(packageNames: string[]) {
    this.packageNames = packageNames;
    this.updateView();
  }

  private updateView(): void {
    const isDefaulter = this.packageService.isDefaulter();
    const userHasAnyPackage = isDefaulter
      ? this.packageNames.some(name => name.toLowerCase() === 'defaulter')
      : this.packageNames.some(name => this.packageService.hasPackage(name));

    if (userHasAnyPackage && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!userHasAnyPackage && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
